<div
	class="d-flex flex-nowrap align-items-start"
	[ngClass]="labelClassObject"
>
	<div
		class="position-relative px-0 {{
			mediaData?.device?.type === deviceTypeEnum.MOBILE || labelInfoInline
			? 'col-auto d-inline-flex flex-shrink-1'
			: 'col d-inline-block'
		}}"
		appIndicateElsterField
		[context]="indicateElsterFieldContextEnum.FORM"
		[indicatesElsterRequiredFormField]="requiredByElster"
		[show]="showElsterIndicator"
		[styleClasses]="'col-auto ps-1 pe-0'"
	>
		<label
			[class.required]="required"
			[ngClass]="labelClassObject"
			for="{{ labelFor }}"
			title="{{ labelTitle }}"
		>{{ labelText }}</label>
		<!--
			Leave `label` content and closing tag on same line, because otherwise
			there may be undesirable line break between label text and indicator for
			required field!
		-->
	</div>
</div>
